export default __webpack_public_path__ + "static/media/5.3697bb98.png";